export default __webpack_public_path__ + "static/media/049-toy store.f4818abc.svg";